<app-manage-template [title]="'Edit Business Network'" [FIELDS]="fields" [COLUMNFIELDS]="columns"
[userData]="(userDatas | async)" [parentData]="businessNetworkDetails" [KEY]="'B2B_NETWORKS'"
(updateParent)="updateBusinessNetwork($event)"  [dropdownContext]="filterData" [holder]="'Search by GSBID#, org name & email ID'"
(updateMembers)="updateBusinessNetworkMembers($event)" [onSearch]="onSearch"
[onFilter]="onFilter" [this]="this" [onScroll]="onScroll"></app-manage-template>
